import { render, staticRenderFns } from "./group-image.vue?vue&type=template&id=650146c8&scoped=true"
import script from "./group-image.vue?vue&type=script&lang=js"
export * from "./group-image.vue?vue&type=script&lang=js"
import style0 from "./group-image.vue?vue&type=style&index=0&id=650146c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650146c8",
  null
  
)

export default component.exports